import { FC, PropsWithChildren } from 'react';

import { Box, Stack } from '@mui/material';

const AuthLayout: FC<PropsWithChildren> = (props) => {
  const blurBackground = '/assets/background/background_1.png';
  const logo = '/assets/logo.png';
  const { children } = props;
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      position="relative"
      gap={3}
      sx={{
        background: `url(${blurBackground})`,
        minHeight: '100vh',
        backgroundSize: 'cover',
        minWidth: '100%',
        backgroundPosition: '50% 50%',
        pt: { xs: 5, md: 0 },
      }}
    >
      <Box
        component="img"
        alt="muse-ai logo"
        src={logo}
        sx={{ position: { md: 'absolute' }, top: 32, left: 30, width: 170 }}
      />
      <Stack
        justifyContent="center"
        alignItems="center"
        sx={{ pt: { xs: 0, md: 14 }, pb: { xs: 5, md: 10 }, width: '100%' }}
      >
        {children}
      </Stack>
    </Stack>
  );
};

export default AuthLayout;
